import { useTranslation } from "react-i18next";
import { Boxes, CreditCard, Package, Wrench } from "lucide-react";

const TONE = {
  inventory: ["bg-sky-500/15 text-sky-600", Boxes],
  consumable: ["bg-amber-500/15 text-amber-600", Package],
  expense: ["bg-emerald-500/15 text-emerald-600", CreditCard],
  asset: ["bg-violet-500/15 text-violet-600", Wrench],
};

// شريحة نوع المادة: مخزنية · استهلاكية · مصاريف/خدمات · أصل ثابت.
export const ItemTypeChip = ({ type, testid }) => {
  const { t } = useTranslation();
  const [tone, Icon] = TONE[type] || TONE.inventory;

  return (
    <span data-testid={testid || `item-type-${type}`}
          className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-bold ${tone}`}>
      <Icon className="h-3.5 w-3.5" />
      {t(`purchases.itemTypes.${type}`)}
    </span>
  );
};
